import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { FnConfirmModalComponent } from './confirm/fn-confirm-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { FnModalService } from './confirm/fn-modal.service';
import { FnCoreModule } from '../../core/index';
import { FoundationModule } from '../../foundation.module';
import { FnDialogHeaderComponent } from './header/fn-dialog-header.component';
import { FnTranslateModule } from './../../i18n/index';

export * from './confirm/fn-confirm-modal.component';
export * from './confirm/fn-modal.service';
export * from './confirm/fn-confirm-modal.component';
export * from './header/fn-dialog-header.component';
/**
 * provide FnModalService to open confirmation and custom Component as modal.
 * making them available for import by NgModules that import this module.
 */

@NgModule({
    imports: [FormsModule, CommonModule, A11yModule, MatDialogModule, FnCoreModule, FoundationModule, FnTranslateModule],
    declarations: [FnConfirmModalComponent, FnDialogHeaderComponent],
    exports: [FnConfirmModalComponent, FnDialogHeaderComponent],
    providers: [FnModalService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class FnDialogModule {
    static forRoot(): ModuleWithProviders<FnDialogModule> {
        return {
            ngModule: FnDialogModule,
            providers: [FnModalService]
        };
    }


}
